module.exports = __webpack_public_path__ + "img/Norte.152d4199.jpg";